import styled, { css } from "styled-components";
import { borderRadius, fontWeights, spacing, typographyMixin } from "@magicbi/ui-library";
import { rawColors } from "../../../design-system/tokens/colors";
import type { LogLineTone } from "./LogLineList.types";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
`;

export const Group = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const GroupHead = styled.header`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
`;

export const GroupTitle = styled.h3`
  margin: 0;
  ${typographyMixin("caption", 4)}
  font-weight: ${fontWeights.bold};
  color: ${rawColors.text.mediumEmphasis};
`;

export const Trailing = styled.span`
  margin-left: auto;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.tertiary};
`;

export const Lines = styled.ol`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Line = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${spacing[2.5]};
  padding: ${spacing[2.5]} ${spacing[3]};
  border-radius: ${borderRadius.lg};
  background: ${rawColors.structural[50]};
`;

export const Tag = styled.span<{ $tone: LogLineTone }>`
  flex: none;
  display: inline-flex;
  align-items: center;
  height: ${spacing[5]};
  padding: 0 ${spacing[1.5]};
  border-radius: ${borderRadius.md};
  ${typographyMixin("caption", 4)}
  font-weight: ${fontWeights.bold};
  white-space: nowrap;
  ${({ $tone }) => {
    switch ($tone) {
      case "success":
        return css`
          background: ${rawColors.accent.tag.success.bg};
          color: ${rawColors.accent.tag.success.fg};
        `;
      case "error":
        return css`
          background: ${rawColors.accent.tag.danger.bg};
          color: ${rawColors.accent.tag.danger.fg};
        `;
      case "info":
        return css`
          background: ${rawColors.accent.tag.info.bg};
          color: ${rawColors.accent.tag.info.fg};
        `;
      case "accent":
        return css`
          background: ${rawColors.accent.tag.accent.bg};
          color: ${rawColors.accent.tag.accent.fg};
        `;
      default:
        return css`
          background: ${rawColors.accent.tag.neutralStrong.bg};
          color: ${rawColors.accent.tag.neutralStrong.fg};
        `;
    }
  }}
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[0.5]};
  min-width: 0;
`;

export const Text = styled.span`
  ${typographyMixin("caption", 3)}
  font-weight: ${fontWeights.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  overflow-wrap: anywhere;
`;

export const Meta = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.tertiary};
  overflow-wrap: anywhere;
`;
